<div class="main d-flex flex-column">
    <div class="filters d-flex align-items-center gap-3">
        <div class="filter-button-container">
            <button class="d-flex gap-3 align-items-center" (click)="filterOpened = !filterOpened">
                <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 3.75H14M6 14.25H10M4 9H12" stroke="#171717" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
                <span>Filter</span>     
            </button>
            <div *ngIf="filterOpened" class="filters-window">
                <lib-nec-filter></lib-nec-filter>
            </div>
        </div>
        <div class="search-filter d-flex align-items-center">
            <div class="search-type d-flex gap-2 align-items-center" (click)="searchDropdownOpened = !searchDropdownOpened">
                <span>Asset Name</span>
                <img height="12" width="12" src="../../../../assets/icons/arrow-down-small.svg" />
            </div>
            <div class="search-bar">
                <img height="16" width="16" src="assets/icons/search.svg" alt="Search icon"/>
                <input type="text" placeholder="Search"/>
            </div>
            <div *ngIf="searchDropdownOpened" class="search-dropdown">
                <ul>
                   <li>Asset Name</li> 
                   <li>Asset Number</li> 
                   <li>Electrical Address</li> 
                   <li>Region</li> 
                </ul>
            </div>
        </div>
    </div>
    <div class="table-container">
        <table>
            <thead>
                <tr>
                    <th class="d-flex align-items-center gap-3">
                        <input class="checkbox" type="checkbox" />
                        <span>
                            Name
                        </span>
                    </th>
                    <th>Code</th>
                    <th>Number</th>
                    <th></th>
                </tr> 
            </thead>
            <tbody>
                <tr *ngFor="let region of regions">
                    <td class="d-flex align-items-center gap-3 h-100">
                      <div class="cell-content">
                        <input class="checkbox" type="checkbox" />
                        <span>
                            {{ region.name | hasValue | uppercase }}
                        </span>
                      </div>
                    <td>
                      <div class="cell-content">
                        <span class="span-padding">
                            {{ region.code | hasValue | uppercase }}
                        </span>
                      </div>
                    </td>
                    <td>
                      <div class="cell-content">
                        <span class="span-padding">
                            {{ region.number | hasValue }}
                        </span>
                      </div>
                    </td>
                    <td class="menu-cell">
                        <div *ngIf="permissionsService.isNetworkEntityClassesCreateEditAllowed || permissionsService.isNetworkEntityClassesDeleteAllowed" class="menu-wrapper cell-content dots-padding">
                            <div class="dots" (click)="toggleActionMenu(region, $event)">
                              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.43647 7.16337L6.15006 9.19769C6.76771 9.6607 7.65378 9.4528 8.00108 8.76344C8.16304 8.44191 8.45676 8.20667 8.80589 8.11883L10.3201 7.73791C11.3039 7.49041 12.0717 6.72137 12.3173 5.7371L13.0568 2.77495M3.43647 7.16337C2.8501 8.31607 2.51953 9.62073 2.51953 11.0026C2.51953 15.6855 6.31579 19.4818 10.9987 19.4818C15.6816 19.4818 19.4779 15.6855 19.4779 11.0026C19.4779 7.02949 16.7452 3.69461 13.0568 2.77495M3.43647 7.16337C4.8372 4.4098 7.69766 2.52344 10.9987 2.52344C11.7085 2.52344 12.3979 2.61065 13.0568 2.77495" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M12.9051 15.5843C13.4236 15.5843 13.8975 15.2915 14.1294 14.8277C14.4373 14.2121 14.2399 13.4635 13.6685 13.0795L12.5205 12.3081C12.157 12.0638 11.7351 11.9204 11.2979 11.8925L10.6919 11.8539C10.3692 11.8332 10.0531 11.9522 9.82404 12.1805C9.44262 12.5605 9.38294 13.1572 9.68168 13.6052L10.2932 14.5225C10.7355 15.1859 11.48 15.5843 12.2773 15.5843H12.9051Z" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </div>
                            <div
                                class="popup-menu"
                                libPopupMenuFlip
                                *ngIf="actionMenuOpenForId === region.id"
                            >
                                <button 
                                    *ngIf="permissionsService.isNetworkEntityClassesCreateEditAllowed"
                                    class="menu-item" 
                                    data-bs-toggle="modal" 
                                    data-bs-target="#editAddModal-7"
                                    (click)="selectRegion(region)"
                                >
                                    Update
                                </button>
                                <button 
                                    *ngIf="permissionsService.isNetworkEntityClassesDeleteAllowed"
                                    class="menu-item" 
                                    data-bs-toggle="modal"
                                    data-bs-target="#deleteBu"
                                >
                                    Remove
                                </button>
                            </div>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="bv-pagination py-4">
         <lib-pagination-new
            [totalItems]="count"
            [pageSize]="pageSize"
            [currentPage]="currentPage"
            [pageSizes]="pageSizes"
            (pageChange)="onPageChange($event)"
            (pageSizeChange)="onPageSizeChange($event)">
        </lib-pagination-new>
    </div>
</div>

<div
  class="modal fade"
  id="deleteBu"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content delete-modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header delete-modal-header">
        <h5 class="modal-title" id="deleteBuTitle">
          {{ "CRUD_SETTINGS.ARE_YOU_SURE_DELETE" | translate }}
          {{ "COMMON.BU.SINGLE" | translate }}?
        </h5>
      </div>
      <div class="modal-footer delete-modal-footer">
        <button 
            type="button" 
            class="btn btn-primary" 
            (click)="onRemove()"
            data-bs-dismiss="modal"
        >
          {{ "COMMON.DELETE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="editAddModal-7" tabindex="-1" aria-labelledby="exampleEditModalLabel" aria-hidden="true">
  <div style="max-width: 64rem;" class="modal-dialog modal-dialog-centered modal-lg">
    <form (ngSubmit)="save()"   
      style="border-radius: 20px;" class="modal-content rounded-5 shadow-lg border-0">
      <div class="modal-header border-0 pb-0">
        <h5 style="font-size: 2rem;" class="modal-title fw-semibold" id="exampleEditModalLabel">{{ isEdit ? "Update Region" : "Add New Region" }}</h5>
        <button type="button" style="border: none; background: transparent;" data-bs-dismiss="modal" aria-label="Zatvori">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="12" fill="#171717" fill-opacity="0.05"/>
            <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#171717" stroke-opacity="0.07"/>
            <path d="M8.375 8.375L15.625 15.625M15.625 8.375L8.375 15.625" stroke="#171717" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      <p class="description-text">{{ isEdit ? "Fill out the fields carefully to update this instance, including all necessary information for identification." : "Fill out the fields carefully to create a new instance, including all necessary information for identification." }}</p>
        <div 
          class="new-instance-modal-body modal-body pt-3 m-0 w-100 align-items-center justify-content-between">
          <div class="section w-100 row">
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Name</p>
            </div>
            <div class="col-6">
              <input 
                class="new-instance-input w-100" 
                type="text"
                name="name"
                [(ngModel)]="updatedName"
                placeholder=" "  
              />
            </div>
          </div>
          <div class="section w-100 row">
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Code</p>
            </div>
            <div class="col-6">
              <input 
                class="new-instance-input w-100" 
                type="text" 
                name="code"
                [(ngModel)]="updatedCode"
                placeholder=" "
              />
            </div>
          </div>
          <div class="section w-100 row">
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Number</p>
            </div>
            <div class="col-6">
              <input 
                class="new-instance-input w-100" 
                type="text" 
                name="number"
                [(ngModel)]="updatedNumber"
                placeholder=" "
                minlength="4"
                maxlength="4"
              />
            </div>
          </div>
          <div class="section w-100 row">
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Latitude</p>
            </div>
            <div class="col-6">
              <input 
                class="new-instance-input w-100" 
                type="number" 
                name="latitude"
                [(ngModel)]="updatedLatitude"
                placeholder=" "  
                type="number"
                step="any"
              />
            </div>
          </div>
          <div class="section w-100 row">
            <div class="label-div d-flex align-items-center justify-content-left col-6">
              <p>Longitude</p>
            </div>
            <div class="col-6">
              <input 
                class="new-instance-input w-100" 
                type="number" 
                name="longitude"
                [(ngModel)]="updatedLongitude"
                placeholder=" "  
                type="number"
                step="any"
              />
            </div>
          </div>
        </div>         
      <div class="modal-footer border-0">
        <button type="button" class="btn cancel-modal-btn" data-bs-dismiss="modal" #closeEditModal>Cancel</button>
        <button type="submit" class="btn save-modal-btn">Save</button>
      </div>
    </form>
  </div>
</div>